import { styled } from "@mui/material/styles"
import { Box } from "@mui/material"

const FlexEvenly = styled(Box)({
	display: "flex",
	justifyContent: "space-evenly",
	alignItems: "center",
})

export default FlexEvenly